import axios from 'axios';
import { useQuery } from '@tanstack/react-query';

import { ResponseList } from 'models';
import { WebMainProgram } from 'models/role/WebMainProgram';

function useWebMainPrograms(sid: string | undefined, platform_id: string | undefined) {
    return useQuery({
        enabled: !!sid && !!platform_id,
        queryKey: ['web-main-programs', { sid, platform_id }],
        queryFn: () => axios.get<ResponseList<WebMainProgram>>('/v1/web-main-programs', {
            params: {
                sid: sid,
                platform_id: platform_id
            }
        }),
        select: response => response.data.result_list,
        refetchOnWindowFocus: false,
        retry: 1
    });
}

export default useWebMainPrograms;
